






































import { EmailAgendamento } from "@/services/email.service";
import { required, validDate, validHora } from "@/shared/validators";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

import DatePicker from "@/shared/components/date-picker.vue";

class EmailAgendamentoForm implements EmailAgendamento {
  dtAgendamento = new Date().toISOString().split("T")[0];
  hrAgendamento = new Date().toTimeString().substring(0, 5);
  enviosHora = 4000;
}

@Component({ components: { DatePicker } })
export default class EmailAgend extends Vue {
  //Atributos
  data: EmailAgendamento = new EmailAgendamentoForm();

  rules = {
    dtAgendamento: [required(), validDate()],
    hrAgendamento: [required(), validHora()],
  };

  //Props
  @Prop() readonly value!: EmailAgendamento;

  mounted() {
    this.onChange(this.data);
  }

  @Watch("value")
  onChange(val: EmailAgendamento | undefined | null) {
    if (val) this.data = val;
    this.emitir();
  }

  emitir() {
    this.$emit("input", this.data);
  }

  reset() {
    this.onChange(new EmailAgendamentoForm());
  }
}
